import React from 'react'
import PropTypes from 'prop-types'
import { Badge, Box, Divider, Typography } from '@mui/material'
import { ModuleDescription, ModuleHeader, ModuleItem, ModuleWrapper } from './elements'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import AssignmentIcon from '@mui/icons-material/Assignment'
import BookIcon from '@mui/icons-material/Book'
import { setLocalStorageData } from '../../utils/storage/storage'
import { useNavigate } from 'react-router-dom'
import { useModule } from '../../context/ModuleContext/ModuleContext'
import { SET_MODULE } from '../../reducers/reducesTypes'
import { BaseService } from '../../services/BaseService'
import { useQuery } from 'react-query'
import { useGetUser } from '../../hooks/useGetUser'

async function fetchHistory(userId) {
  const service = new BaseService('/m_history_2')
  const res = await service.getHistory({
    id_user: userId,
  })

  return res.data
}
const Module = ({ data }) => {
  const navigate = useNavigate()
  const { dispatch } = useModule()
  const { user } = useGetUser()

  const { data: dataHistory } = useQuery({
    queryKey: ['rules-history', user.id],
    queryFn: async () => await fetchHistory(user.id),
  })
  // console.log(dataHistory.data)

  function handleClick(module) {
    let newPayload = {}
    for (let a in module) {
      if (a !== 'deskripsi') {
        newPayload[a] = module[a]
      }
    }
    const toString = JSON.stringify(newPayload)
    const encode = btoa(toString)
    setLocalStorageData('module', encode)
    dispatch({
      type: SET_MODULE,
      payload: newPayload,
    })
    navigate(`/rules/${module.id}`)
  }
  return (
    <Box width={'100%'}>
      {Array.isArray(data) &&
        data?.map((module, idx) => (
          <Box
            key={idx}
            onClick={() => handleClick(module)}
            sx={{
              cursor: 'pointer',
            }}
          >
            <ModuleWrapper
              sx={{
                backgroundColor: ({ palette }) =>
                  palette[idx % 2 === 0 ? 'background.4' : 'background.2']['light'],
              }}
            >
              <ModuleItem>
                <ModuleHeader
                  sx={{
                    mb: '10px !important',
                  }}
                >
                  <FiberManualRecordIcon
                    fontSize="small"
                    sx={{
                      mr: 2,
                      mt: '2px',
                    }}
                  />
                  {module.nama_modul}
                  {dataHistory?.data?.filter((h) => h.id === module.id).length > 0 ? (
                    <Badge
                      sx={{
                        marginRight: '25px',
                        marginLeft: 'auto',
                        zIndex: 0,
                      }}
                      badgeContent={'DONE'}
                      color="success"
                    ></Badge>
                  ) : null}
                </ModuleHeader>
                <ModuleDescription dangerouslySetInnerHTML={{ __html: module.deskripsi.replace(/\n/g, ' ') }} />
                <Divider
                  sx={{
                    my: 1,
                  }}
                />
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Typography
                    variant="body2"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <AccessTimeIcon
                      fontSize="small"
                      sx={{
                        mr: 2,
                      }}
                    />
                    {module.waktu_pengerjaan} Menit
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <AssignmentIcon
                      fontSize="small"
                      sx={{
                        mr: 2,
                      }}
                    />
                    {module.jumlah_soal} Soal
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <BookIcon
                      fontSize="small"
                      sx={{
                        mr: 2,
                      }}
                    />
                    {module.tipe_modul}
                  </Typography>
                </Box>
              </ModuleItem>
            </ModuleWrapper>
          </Box>
        ))}
    </Box>
  )
}

Module.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      description: PropTypes.string,
      child: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          title: PropTypes.string,
          timer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          type: PropTypes.string,
          total: PropTypes.string,
        }),
      ),
    }),
  ),
}

export default Module
